module.exports = __webpack_public_path__ + "static/factory.8ebc3a4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/schools/factory.jpg
// module id = 503
// module chunks = 68528197934321